/* eslint-disable react/jsx-no-target-blank */
import React, { useState } from 'react'

import { Button, Card, Col, Icon, notification, Row, Select, Typography, Upload } from 'antd'

import { CustomBreadcrumb } from '../../components/CustomBreadcrumb/CustomBreadcrumb'
import FormHeader from '../../components/FormHeader/FormHeader'
import { validRule, RULES } from '../../constants/Entitlements'
import { api, request } from '../../util/handlerRequestUtil'
import { getMessage } from '../../util/IntlMessages'

const { Option } = Select
const { Dragger } = Upload

const Importation = function ({ match, history }) {
  const [selectedType, setSelectedType] = useState('')
  const [file, setFile] = useState(null)

  const hasAccess = validRule(RULES.FILE_IMPORT_LIST) // Não deixa acessar a tela
  if (!hasAccess) {
    return history.push('/home')
  }

  const importationTypes = []
  if (validRule(RULES.FILE_IMPORT_CUSTOMER)) {
    importationTypes.push({
      value: 'customers',
      description: getMessage('customer')
    })
  }

  //   If (validRule(RULES.FILE_IMPORT_LOCATION)) {
  //     importationTypes.push({
  //       value: 'locations',
  //       description: getMessage('locations')
  //     })
  //   }
  if (validRule(RULES.FILE_IMPORT_MEMBER)) {
    importationTypes.push({
      value: 'members',
      description: getMessage('users')
    })
  }

  if (validRule(RULES.FILE_IMPORT_REGION)) {
    importationTypes.push({
      value: 'regions',
      description: getMessage('regionals')
    })
  }

  if (validRule(RULES.FILE_IMPORT_DISTRICT)) {
    importationTypes.push({
      value: 'districts',
      description: getMessage('district')
    })
  }

  const handleSelectedTypeChange = (value) => {
    setSelectedType(value)
  }

  const renderOptions = () => {
    const options = []
    for (const type of importationTypes) {
      options.push(<Option value={type.value}>{type.description}</Option>)
    }

    return options
  }

  const draggerProps = {
    name: 'file',
    multiple: false,
    onChange(info) {
      setFile(info.file)
    },
    beforeUpload: () => {
      return false
    }
  }

  const handleUpload = async () => {
    try {
      const formData = new FormData()
      formData.append('file', file)
      if (selectedType) {
        if (selectedType === 'customers') {
          await request(api.uploadCustomerImportationFile(formData))
        }

        if (selectedType === 'locations') {
          await request(api.uploadLocationImportationFile(formData))
        }

        if (selectedType === 'members') {
          await request(api.uploadMembersImportationFile(formData))
        }

        if (selectedType === 'regions') {
          await request(api.uploadRegionImportationFile(formData))
        }

        if (selectedType === 'districts') {
          await request(api.uploadDistrictImportationFile(formData))
        }
      }

      notification.success({
        description: getMessage('importSuccess', getMessage(selectedType)),
        message: getMessage('sweetAlerts.success')
      })
    } catch (error) {
      notification.error({
        description: getMessage('importFail'),
        message: 'Operação falhou'
      })
    }
  }

  return (
    <>
      <div>
        <div>
          <CustomBreadcrumb match={match} history={history} />
        </div>

        <Row>
          <Col span={20}>
            <Typography.Title level={3}>{getMessage('importation')}</Typography.Title>
          </Col>
          <Col span={4}>
            <div className="default-header-breadcrumb">
              <Button className="bgPrimary" type="primary" size="large" block onClick={handleUpload}>
                {getMessage('send')}
              </Button>
            </div>
          </Col>
        </Row>
      </div>

      <Card className="ant-card gx-card ant-card-bordered" style={{ height: '70vh' }}>
        <FormHeader
          style={{
            position: 'relative',
            left: '-10px',
            width: 'calc(100% + 10px)'
          }}
          title={getMessage('files')}
          orientation="left"
          type="horizontal"
        />
        <Row>
          <Col span={6}>
            <p>{getMessage('importationType')}</p>
            <Select
              style={{ width: '100%', marginBottom: '20px' }}
              placeholder={getMessage('select')}
              onChange={handleSelectedTypeChange}
            >
              {renderOptions()}
            </Select>
            {selectedType ? (
              <a href={`${process.env.REACT_APP_API_URL}/import-models/download/${selectedType}`} target="_blank">
                <Button className="bgPrimary" type="primary" size="large" block>
                  <Icon style={{ fontSize: '24px', position: 'relative', top: '4px' }} type="cloud-download" />
                  {getMessage('spreadsheetModel')}
                </Button>
              </a>
            ) : null}
          </Col>
          {selectedType ? (
            <Col span={14} style={{ marginLeft: '16.7%' }}>
              <Dragger {...draggerProps}>
                <p className="ant-upload-drag-icon">
                  <Icon type="inbox" />
                </p>
                <p className="ant-upload-text">{getMessage('importationDragInstruction', getMessage(selectedType))}</p>
              </Dragger>
            </Col>
          ) : (
            <Col span={14} style={{ marginLeft: '16.7%', textAlign: 'center' }}>
              <Typography.Title level={4}>{getMessage('selectImportationType')}</Typography.Title>
            </Col>
          )}
        </Row>
      </Card>
    </>
  )
}

export default Importation
